import { BaseTable } from "components";
import { useContext } from "react";
import { FormDataContext } from "../../context";
import moment from "moment";
import { convertNumber } from "utils";

export function TabHistori() {

    const { dataAsset } = useContext(FormDataContext)

    const dateNow = moment();
    const dateAquisition = moment(dataAsset?.acquisition_date, "YYYY-MM-DD");
    const assetAge = (dateNow.diff(dateAquisition, 'days') / 365).toFixed(2);

    const totalValue = dataAsset?.history.reduce((total, item) => total + Number(item.depreciation_expenses), 0);
    


    return (
        <section className="py-5 px-6">
            <div className="font-bold mb-4 bg-slate-400 p-2 dark:text-white rounded-sm">HISTORY</div>
            <div className="mt-10">
                <div className="flex-col gap-2">
                    <div className="font-bold text-md flex">
                        <div className="w-[200px]">DEPRECIATION PERIODE</div>
                        <span>:</span>
                        <div className="ml-2">{Number(dataAsset?.depreciation_period) === 1 ? "MONTH" : "YEAR"}</div>
                    </div>
                    <div className="font-bold text-md flex">
                        <div className="w-[200px]">ASSET AGE</div>
                        <span>:</span>
                        <div className="ml-2">{assetAge} YEAR</div>
                    </div>
                    <div className="font-bold text-md flex">
                        <div className="w-[200px]">DEPRECIATION METODE</div>
                        <span>:</span>
                        <div className="ml-2">{Number(dataAsset?.depreciation_methode) === 1 ? "STRAIGHT LINE" : ""}</div>
                    </div>
                </div>
            </div>
            <div className="mt-6">
                <BaseTable>
                    <thead className="!bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>PERIODE</th>
                            <th>DATE</th>
                            <th>DEPRECIATION EXPENCES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataAsset?.history && dataAsset?.history.length === 0 ? (
                            <tr>
                                <td colSpan={4} className="text-center">No data available</td>
                            </tr>
                        ) : (
                            dataAsset?.history.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{moment(`${item.year}-${item.month}`, "YYYY-M").format("MMMM YYYY")}</td>
                                    <td>{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                                    <td className="text-right">{item.depreciation_expenses ? convertNumber(Number(item.depreciation_expenses)).intoCurrency : "-"}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan={3} className="text-right font-bold text-black">ACCUMULATION DEPRECIATION</th>
                            <th className="font-bold text-black text-right">{totalValue ? convertNumber(totalValue).intoCurrency : "-"}</th>
                        </tr>
                    </tfoot>
                </BaseTable>
            </div>
        </section>
    )
}